module.exports = __webpack_public_path__ + "media/flags/nz-f113106d.svg";